<script>
import options from './Dictionary.options'
export default options
</script>

<template></template>
